module.exports = __webpack_public_path__ + "static/assets/a8118d3175b26ae9cb069df88a92e4a2.gif";